<script lang="ts">
  import { navigate, goHome, type Route } from '../../stores/router';

  interface Props {
    items: { label: string; route?: Route }[];
  }

  let { items }: Props = $props();
</script>

<nav aria-label="Breadcrumb" class="flex items-center gap-1.5 text-sm">
  <!-- Home icon -->
  <button
    onclick={goHome}
    class="text-text-muted hover:text-accent transition-colors p-0.5"
    aria-label="Home"
  >
    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1" />
    </svg>
  </button>

  {#each items as item, i (i)}
    <span class="text-text-muted">/</span>
    {#if i < items.length - 1 && item.route}
      <button
        onclick={() => navigate(item.route!)}
        class="text-text-secondary hover:text-accent transition-colors"
      >
        {item.label}
      </button>
    {:else}
      <span class="text-text-primary font-medium">{item.label}</span>
    {/if}
  {/each}
</nav>
